<template>
  <div class="login" v-show="initForm">
    <div class="login-box">
      <div class="login-box-login" >
        <el-form :model="loginFrom" :rules="rules" ref="loginFrom">
          <el-form-item label="" prop="userName">
            <el-input v-model.trim="loginFrom.userName" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input type="password" v-model.trim="loginFrom.password" placeholder="请输入密码" @keyup.enter.native="login"></el-input>
          </el-form-item>
        </el-form>
        <el-checkbox v-model="checked">记住密码</el-checkbox>
        <div class="login-add">
          <el-button size="small" @click="login">登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/pages/home/api'

export default {
  name: 'app',
  data () {
    return {
      loginFrom: {
        userName: '',
        password: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      initForm: true,
      checked: true
    }
  },
  methods: {
    init () {
      var _this = this
      let res = this.getUrlParam('n', 'p')
      if (res) {
        _this.initForm = false
        if (res[0] === 'bjadmin' && res[1] === 'bitnei@1217') {
          _this.$emit('loginLoading', true)
          _this.loginFrom.userName = res[0]
          _this.loginFrom.password = res[1]
          setInterval(() => {
            _this.login()
          }, 500)
        } else {
          _this.initForm = true
          _this.$emit('loginLoading', false)
        }
      } else {
        _this.initForm = true
        _this.$emit('loginLoading', false)
      }
    },
    getUrlParam (paraName, paraPassw) {
      let url = document.location.toString()
      let arrObj = url.split('?')
      if (arrObj.length > 1) {
        let arrPara = arrObj[1].split('&')
        var arrList = []
        if (arrPara.length !== 2) return false
        for (let i = 0; i < arrPara.length; i++) {
          let arr = arrPara[i].split('=')
          if (arr[0] === paraName) {
            arrList.push(arr[1])
          }
          if (arr[0] === paraPassw) {
            arrList.push(arr[1])
          }
        }
        return arrList
      } else {
        return false
      }
    },
    login () {
      let _this = this
      _this.$refs.loginFrom.validate(valid => {
        if (valid) {
          api
            .getLoginCount(this.loginFrom)
            .then(res => {
              let data = res.data.meta
              if (data.code === 0) {
                if (_this.checked) {
                  window.sessionStorage.setItem('userName', _this.loginFrom.userName)
                  window.sessionStorage.setItem('password', _this.loginFrom.password)
                  _this.setCookie(
                    _this.loginFrom.userName,
                    _this.loginFrom.password,
                    7
                  )
                } else {
                  _this.clearCookie()
                }
                _this.$emit('loginLoading', false)
                window.sessionStorage.setItem('token', res.data.token)
                window.location.href = '/index.html'
              } else {
                this.$message({
                  message: data.message,
                  type: 'error'
                })
              }
            })
            .catch(e => {})
        }
      })
    },
    setCookie (name, pwd, exdays) {
      var exdate = new Date()
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)
      window.document.cookie =
        'userName' + '=' + name + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie =
        'userPwd' + '=' + pwd + ';path=/;expires=' + exdate.toGMTString()
    },
    clearCookie () {
      this.setCookie('', '', -1)
    },
    getCookie () {
      if (document.cookie.length) {
        let arr = document.cookie.split('; ')
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=')
          if (arr2[0] === 'userName') {
            this.loginFrom.userName = arr2[1]
          } else if (arr2[0] === 'userPwd') {
            this.loginFrom.password = arr2[1]
          }
        }
      }
    }
  },
  mounted () {
    window.sessionStorage.clear()
    this.getCookie()
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.login-box {
  width: 20.53rem;
  height: 9.75rem;
  background: url("../../assets/images/login.png") no-repeat;
  background-size: 100% 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  .login-box-login {
    width: 10.11rem;
    margin: 1.9rem auto;
  }
}
</style>

<style lang="scss">
.login-box {
  .el-input__inner {
    border: 0.01rem solid rgba(39, 227, 255, 0.65);
    background-color: transparent;
    color: #fff;
    width: 100%;
    height: 1.08rem;
    line-height: 1.08ren;
  }
  .el-input__inner::-webkit-input-placeholder {
    color: #ccc;
    font-size: 0.3rem;
  }
  .el-input__inner::-moz-placeholder {
    color: #ccc;
    font-size: 0.3rem;
  }
  .el-input__inner::-ms-input-placeholder {
    color: #ccc;
    font-size: 0.3rem;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border: 0.01rem solid rgba(39, 227, 255, 0.65);
  }
  .el-input__inner:hover {
    border: 0.01rem solid rgba(39, 227, 255, 0.65);
  }
  .el-checkbox {
    color: #253b4b;
    margin-bottom: 0.3rem;
  }
  .el-form-item {
    margin-bottom: 0.5rem;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: transparent;
    border-color: #253b4b;
  }
  .el-checkbox__inner {
    background-color: transparent;
    border-color: #253b4b;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label,
  .el-checkbox__label {
    font-size: 0.42rem;
    color: #07e2f2;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner,
  .el-checkbox__inner:hover {
    border-color: #253b4b;
  }
  .login-add {
    .el-button {
      width: 100%;
      height: 1.08rem;
      background-color: transparent;
      border: 0.01rem solid rgba(39, 227, 255, 0.65);
      span {
        letter-spacing: 0.2rem;
        font-size: 0.48rem;
        color: #07e2f2;
      }
    }
  }
}
</style>
